/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automatic_Save_Reload_Records_ButtonInputs */

const en_automatic_save_reload_records_button = /** @type {(inputs: Automatic_Save_Reload_Records_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reload Records`)
};

const fr_automatic_save_reload_records_button = /** @type {(inputs: Automatic_Save_Reload_Records_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recharger les enregistrements`)
};

const de_automatic_save_reload_records_button = /** @type {(inputs: Automatic_Save_Reload_Records_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datensätze neu laden`)
};

const it_automatic_save_reload_records_button = /** @type {(inputs: Automatic_Save_Reload_Records_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ricarica i record`)
};

const ru_automatic_save_reload_records_button = /** @type {(inputs: Automatic_Save_Reload_Records_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Перезагрузить записи`)
};

const es_automatic_save_reload_records_button = /** @type {(inputs: Automatic_Save_Reload_Records_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recargar registros`)
};

const zh_cn2_automatic_save_reload_records_button = /** @type {(inputs: Automatic_Save_Reload_Records_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重新加载记录`)
};

const ja_automatic_save_reload_records_button = /** @type {(inputs: Automatic_Save_Reload_Records_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`レコードをリロード`)
};

const hi_automatic_save_reload_records_button = /** @type {(inputs: Automatic_Save_Reload_Records_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`रिकॉर्ड पुनः लोड करें`)
};

const pt_pt2_automatic_save_reload_records_button = /** @type {(inputs: Automatic_Save_Reload_Records_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recarregar registros`)
};

/**
* | output |
* | --- |
* | "Reload Records" |
*
* @param {Automatic_Save_Reload_Records_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const automatic_save_reload_records_button = /** @type {((inputs?: Automatic_Save_Reload_Records_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automatic_Save_Reload_Records_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_automatic_save_reload_records_button(inputs)
	if (locale === "de") return de_automatic_save_reload_records_button(inputs)
	if (locale === "it") return it_automatic_save_reload_records_button(inputs)
	if (locale === "ru") return ru_automatic_save_reload_records_button(inputs)
	if (locale === "es") return es_automatic_save_reload_records_button(inputs)
	if (locale === "zh-CN") return zh_cn2_automatic_save_reload_records_button(inputs)
	if (locale === "ja") return ja_automatic_save_reload_records_button(inputs)
	if (locale === "hi") return hi_automatic_save_reload_records_button(inputs)
	if (locale === "pt-PT") return pt_pt2_automatic_save_reload_records_button(inputs)
	return en_automatic_save_reload_records_button(inputs)
});